export const AssetGroupUrlTarget = {
  parent: 'AssetGroup',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Asset Group Url Target',
    },
    AssetGroupId: {
      'bulk-upload-header': 'Parent ID',
    },
    Condition1: {
      'bulk-upload-header': 'Asset Group Target Condition 1',
    },
    Operator1: {
      'bulk-upload-header': 'Asset Group Target Condition Operator 1',
    },
    Value1: {
      'bulk-upload-header': 'Asset Group Target Value 1',
    },
    Condition2: {
      'bulk-upload-header': 'Asset Group Target Condition 2',
    },
    Operator2: {
      'bulk-upload-header': 'Asset Group Target Condition Operator 2',
    },
    Value2: {
      'bulk-upload-header': 'Asset Group Target Value 2',
    },
    Condition3: {
      'bulk-upload-header': 'Asset Group Target Condition 3',
    },
    Operator3: {
      'bulk-upload-header': 'Asset Group Target Condition Operator 3',
    },
    Value3: {
      'bulk-upload-header': 'Asset Group Target Value 3',
    },
    AssetGroupUrlTargetId: {
      'bulk-upload-header': 'Id',
    },
    Status: {
      'bulk-upload-header': 'Status',
    },
  },
};
